{
  "07e1519cd01a1150": "Estado de charting",
  "0c3ce3fefa044ee7": "Recordatorio de registro creado exitosamente",
  "0eb0d01798771592": "Nota de recuerdo",
  "0ed27b1c0f670221": "Registro verificado exitosamente para {{workerName}}",
  "11a6767d5674c7e4": "Hecho",
  "1298f382394c84cd": "Todo en orden: no hay recuerdos en progreso",
  "19766ed6ccb2f4a3": "Cancelar",
  "19c73a5cdf346d96": "Profesional",
  "19e13435115479ea": "Recordar nuevamente",
  "22b8701f928b506a": "Todos los tipos de licencia",
  "253304095a1bcdd2": "No hay turnos coincidentes durante este rango de tiempo",
  "294fa874ea6514e3": "Nota de recordatorio:",
  "2e544a292f6979ed": "Turno",
  "2e71da3a95d291bc": "Buscar un profesional",
  "2f040e8849968259": "Error al informar {{workerName}}: {{message}}",
  "31bd5db3eee7a15e": "Crear recordatorio",
  "31e392d1c0378bec": "Aplicar",
  "3e0c029234155245": "Fecha del turno",
  "546ebb8eb993ea56": "Filtros",
  "557623c48457054d": ". Tienen {{hours}} hora para regresar a su lugar de trabajo y asegurarse de que sus registros estén listos para auditoría.",
  "58bb31253b227e14": "Reportar como incompleto",
  "5a1f27056c4bc26e": "Por favor, confirme que {{workerName}} ha completado toda la documentación pendiente para este turno en su lugar de trabajo. No podrá recordarlos nuevamente para este turno.",
  "5bc8cd7dfb5f5ec0": "Recordar para charting",
  "5e231b20808f1921": "Error al recordar a {{workerName}}: {{message}}",
  "66d50aca56da2386": ". Tienen {{hours}} horas para regresar a su lugar de trabajo y asegurarse de que sus registros estén listos para auditoría.",
  "72f256afd196ceae": "Tipo de licencia",
  "78d066e77b15d04e": "El registro no fue iniciado",
  "7eb8b42fec603757": "Recordatorios en progreso",
  "7fce8c12f5c04833": "El registro fue parcialmente completo",
  "875c63a7d3bce041": "Por favor, deje una nota para el profesional especificando qué parte del charting estaba incompleta.",
  "88b4e196562e9d6c": "Sí, marcar el registro como completo",
  "8a8fd5cf53233987": "Rango de fechas del turno",
  "9255b9f3385cf9ed": "Error al verificar el registro para {{workerName}}: {{errorMessage}}",
  "95e445f6311803b9": "Todos los turnos",
  "973845052fa7ac8b": "Filtrar informes de charting",
  "a472b75dd9eff44b": "Gerente de Cumplimiento de Charting",
  "a8283ade31856f71": "Deshacer",
  "b41fd589ad91ed78": "Enviar informe",
  "c170bc77f0f09ba4": "Reportado por",
  "c286ef143acc2459": "Si un profesional deja el charting incompleto, puede recordarlo para que lo complete",
  "c8ed5004a3a6e5d0": "¿Ha regresado {{workerName}} para completar el registro?",
  "cbd247e4246f0cb2": "Recordar a {{workerName}} para completar el registro",
  "d34fef882db4af9b": "Rango seleccionado",
  "d8d623efaf5a6057": "Informe del registro creado exitosamente",
  "daee7606b339f3c3": "Reiniciar",
  "de0b992e815a9143": "Abrir filtros de charting",
  "eb1348d4c4294fe6": "Proporcione detalles sobre qué aún necesita ser completado (por ejemplo, signos vitales, medicamentos, notas de progreso)",
  "eea2745e2867a677": "Verificar",
  "f91e0c5b9e2b5ec3": "sin costo",
  "fbac2fb49360402d": "Informe de registro incompleto"
}
